<template>
  <v-dialog v-model="visible" max-width="100%">
    <v-card style="overflow-y: hidden">
      <v-card-title class="py-2 px-4">{{ titulo }}</v-card-title>

      <v-divider class="my-0"></v-divider>

      <v-card-text class="pa-4">
        <v-form>
          <v-row dense>
            <v-col cols="12" sm="6" md="4" lg="3">
              <v-text-field
                v-model="form.numeroComprobante"
                type="number"
                label="N° Comprobante"
                outlined
                dense
                hide-details
                clearable></v-text-field>

              <small v-for="error in errores.numeroComprobante" :key="error" class="d-block text-danger">
                {{ error }}
              </small>
            </v-col>

            <v-col cols="12" sm="6" md="4" lg="3">
              <v-menu
                ref="menuFechaDepositoRef"
                v-model="menuFechaDeposito"
                transition="scale-transition"
                :close-on-content-click="false"
                offset-y
                min-width="auto">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="form.fechaDeposito"
                    label="Fecha Depósito"
                    prepend-icon="mdi-calendar"
                    outlined
                    dense
                    hide-details
                    readonly
                    clearable
                    v-bind="attrs"
                    v-on="on"></v-text-field>
                </template>

                <v-date-picker v-model="form.fechaDeposito" no-title scrollable @input="menuFechaDeposito = false">
                  <v-spacer></v-spacer>

                  <v-btn text color="primary" @click="menu = menuFechaDeposito"> Cancelar </v-btn>

                  <v-btn text color="primary" @click="$refs.menuFechaDepositoRef.save(form.fechaDeposito)">
                    Aceptar
                  </v-btn>
                </v-date-picker>
              </v-menu>

              <small v-for="error in errores.fechaDeposito" :key="error" class="d-inline-block text-danger">
                {{ error }}
              </small>
            </v-col>

            <v-col cols="12" sm="12" md="4" lg="6">
              <div class="d-flex">
                <v-file-input
                  v-model="archivo"
                  placeholder="Seleccione un archivo"
                  accept="image/jpeg, image/png, image/jpg, application/pdf"
                  label="Comprobante de Pago (JPG, PNG, PDF)"
                  outlined
                  dense
                  hide-details
                  clearable
                  @change="onFileChange"></v-file-input>

                <v-btn
                  class="ml-2"
                  title="Previsualizar archivo"
                  color="primary"
                  icon
                  :disabled="!archivo || !previsualizacion"
                  @click="verPrevisualizacionArchivo">
                  <v-icon>mdi-file-eye</v-icon>
                </v-btn>
              </div>
            </v-col>

            <v-col cols="12" md="9" xl="10">
              <v-btn
                class="mx-1"
                color="primary"
                title="Agregar Estudiantes"
                small
                @click="$refs.modalFormularioDetallesSolicitudesPagosAgrupados.abrir(accionesCrud.REGISTRAR, [])">
                <v-icon>mdi-plus</v-icon>

                Agregar Estudiantes
              </v-btn>

              <v-btn
                small
                class="mx-1"
                :disabled="item == null"
                title="Eliminar"
                @click="() => quitarItem(item.detalleSolicitudPagoId)">
                <v-icon>mdi-close</v-icon>

                Quitar
              </v-btn>
            </v-col>

            <v-col cols="12">
              <ListadoDetallesSolicitudesPagosAgrupados
                ref="listadoRef"
                :items="detallesSolicitudesPagosAgrupados"
                :cargando="cargando"
                @selectItem="selectItem" />
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-divider class="my-0"></v-divider>

      <v-card-actions>
        <v-btn color="blue darken-1" text @click.prevent="cerrar"> Cerrar </v-btn>

        <v-btn
          color="blue darken-1"
          text
          :loading="enviando"
          :disabled="enviando"
          @click.prevent="$refs.confirmacionRef.abrir">
          Guardar
        </v-btn>
      </v-card-actions>
    </v-card>

    <ConfirmacionAccion
      ref="confirmacionRef"
      :titulo="confirmacion.titulo"
      :mensaje="confirmacion.mensaje"
      :realizandoAccion="confirmacion.realizandoAccion"
      @aceptar="confirmacion.fnAceptar" />

    <ModalDetallesSolicitudesPagosAgrupados
      ref="modalFormularioDetallesSolicitudesPagosAgrupados"
      :nombreRecurso="nombreItem"
      :solicitudPagoId="form.solicitudPagoId"
      :detallesSolicitudesPagosAgrupados="detallesSolicitudesPagosAgrupados"
      :detallePagoConceptoUniversidadCuotaAnterior="detallePagoConceptoUniversidadCuotaAnterior"
      :inscripcionesProgramasUniversidadesPagadasDeCuotaAnterior="
        inscripcionesProgramasUniversidadesPagadasDeCuotaAnterior
      "
      @agregarDetallesPagosUniversidadesAgrupados="agregarDetallesPagosUniversidadesAgrupados" />

    <ModalVerPdf ref="modalVerPdfRef" />
  </v-dialog>
</template>

<script>
import 'vue-select/dist/vue-select.css';
import PagoUniversidadPadreService from '../services/pago-universidad-padre.service';
import modalFormMixin from '../mixins/modal-form.mixin';
import apiConsumerMixin from '../mixins/api-consumer.mixin';
import ConfirmacionAccion from '../components/ConfirmacionAccion.vue';
import ListadoDetallesSolicitudesPagosAgrupados from './ListadoDetallesSolicitudesPagosAgrupados.vue';
import layoutMixin from '../mixins/layout.mixin';
import ModalDetallesSolicitudesPagosAgrupados from './ModalDetallesSolicitudesPagosAgrupados.vue';
import cuotaAnteriorMixin from '../mixins/cuota-anterior.mixin';
import { concatenar } from '../utils/funciones';
import pagoUniversidadMixin from '../mixins/pago-universidad.mixin';

export default {
  name: 'ModalFormularioPagoUniversidadAgrupados',
  mixins: [modalFormMixin, apiConsumerMixin, layoutMixin, cuotaAnteriorMixin, pagoUniversidadMixin],
  components: {
    ConfirmacionAccion,
    ListadoDetallesSolicitudesPagosAgrupados,
    ModalDetallesSolicitudesPagosAgrupados,
  },
  props: {
    solicitudPagoId: {
      type: [Number, null],
      required: true,
    },
  },
  data() {
    return {
      nombreItem: 'Detalle Solicitud Pago',
      menuFechaDeposito: false,
      confirmacion: {
        titulo: 'Guardar el Pago de la Universidad',
        mensaje: '¿Está seguro que desea realizar el pago de la universidad?',
        realizandoAccion: false,
        fnAceptar: () => this.validar(this.registrar, this.editar),
      },
      archivo: null,
      detallesSolicitudesPagosAgrupados: [],
    };
  },
  watch: {
    'form.numeroComprobante': function () {
      this.errores.numeroComprobante = [];
    },
    'form.fechaDeposito': function () {
      this.errores.fechaDeposito = [];
    },
    enviando: function (value) {
      this.confirmacion.realizandoAccion = value;
    },
  },
  methods: {
    generarObjetoFormRegistrar() {
      this.archivo = null;
      this.detallesSolicitudesPagosAgrupados = [];

      return {
        id: null,
        solicitudPagoId: this.solicitudPagoId,
        numeroComprobante: null,
        fechaDeposito: null,
        nombreDepositante: concatenar(
          this.$store.state.DATA_USER.nombres,
          this.$store.state.DATA_USER.pri_apellido,
          this.$store.state.DATA_USER.seg_apellido,
        ),
        depositanteId: this.$store.state.DATA_USER.id,
        pagosUniversidades: [],
        detallesPagosUniversidades: [], // borrar
      };
    },
    generarObjetoFormEditar(data) {
      return {
        id: data.id,
        solicitudPagoId: data.solicitudPagoId,
        numeroComprobante: data.numeroComprobante,
        fechaDeposito: data.fechaDeposito,
        nombreDepositante: data.nombreDepositante,
        depositanteId: data.depositanteId,
        pagosUniversidades: data.pagosUniversidades,
        detallesPagosUniversidades: data.detallesPagosUniversidades, // borrar
      };
    },
    abrir(accion, data = []) {
      this.abrirMixin(accion, data);
    },
    guardar(accion) {
      const formData = new FormData();

      Object.keys(this.form).forEach((key) => {
        if (
          this.form[key] !== null &&
          this.form[key] !== undefined &&
          this.form[key] !== '' &&
          key !== 'pagosUniversidades'
        ) {
          formData.append(key, this.form[key]);
        }
      });

      this.form.pagosUniversidades.forEach((pagoUniversidad, i) => {
        formData.append(`pagosUniversidades[${i}][solicitudPagoId]`, pagoUniversidad.solicitudPagoId);

        pagoUniversidad.detallesPagosUniversidades.forEach((detallePagoUniversidad, j) => {
          formData.append(
            `pagosUniversidades[${i}][detallesPagosUniversidades][${j}][detalleSolicitudPagoId]`,
            detallePagoUniversidad.detalleSolicitudPagoId,
          );

          if (detallePagoUniversidad.observacion) {
            formData.append(
              `pagosUniversidades[${i}][detallesPagosUniversidades][${j}][observacion]`,
              detallePagoUniversidad.observacion,
            );
          }
        });
      });

      if (this.archivo) {
        formData.append('archivo', this.archivo);
      }

      this.guardarDatosMixin(
        PagoUniversidadPadreService.create,
        PagoUniversidadPadreService.update,
        accion,
        formData,
        this.nombreRecurso,
        () => {
          this.$emit('actualizarListado');
          this.cerrar();
        },
        (errores) => {
          this.errores = errores;
        },
      );
    },
    registrar() {
      this.guardar(this.accionesCrud.REGISTRAR);
    },
    editar() {
      this.guardar(this.accionesCrud.EDITAR);
    },
    agregarDetallesPagosUniversidadesAgrupados(detallesSolicitudesPagosAgrupados) {
      detallesSolicitudesPagosAgrupados.forEach((detalle) => {
        const inscripcionProgramaUniversidad = detalle.inscripcionProgramaUniversidad;
        const { inscripcion } = inscripcionProgramaUniversidad;
        const { estudiante, programa } = inscripcion;

        this.detallesSolicitudesPagosAgrupados.push({
          id: null,
          solicitudPagoId: detalle.solicitudPagoId,
          solicitudPago: detalle.solicitudPago,
          detalleSolicitudPagoId: detalle.id,
          inscripcionProgramaUniversidad: {
            id: inscripcionProgramaUniversidad.id,
            inscripcion: {
              id: inscripcion.id,
              estudiante: {
                id: estudiante.id,
                nombres: estudiante.nombres,
                numeroDocumento: estudiante.numeroDocumento,
                primerApellido: estudiante.primerApellido,
                segundoApellido: estudiante.segundoApellido,
                sexo: estudiante.sexo,
                telefono1: estudiante.telefono1,
                telefono2: estudiante.telefono2,
                email: estudiante.email,
                profesiones: estudiante.profesiones,
                institucion: estudiante.institucion,
              },
              programaId: inscripcion.programaId,
              programa: {
                id: programa.id,
                nombreCompuesto: programa.nombreCompuesto,
                sedeId: programa.sedeId,
                sede: {
                  id: programa.sede.id,
                  nombre: programa.sede.nombre,
                },
              },
            },
          },
          observacion: null,
          creadoEn: null,
        });
      });

      this.detallesSolicitudesPagosAgrupados.forEach((detalle) => {
        const indicePagoUniversidad = this.form.pagosUniversidades.findIndex(
          (pagoUniversidad) => pagoUniversidad.solicitudPagoId == detalle.solicitudPagoId,
        );

        if (indicePagoUniversidad === -1) {
          this.form.pagosUniversidades.push({
            id: null,
            solicitudPagoId: detalle.solicitudPagoId,
            detallesPagosUniversidades: [
              {
                id: null,
                detalleSolicitudPagoId: detalle.detalleSolicitudPagoId,
                observacion: detalle.observacion,
              },
            ],
          });
        } else {
          this.form.pagosUniversidades[indicePagoUniversidad].detallesPagosUniversidades.push({
            id: null,
            detalleSolicitudPagoId: detalle.detalleSolicitudPagoId,
            observacion: detalle.observacion,
          });
        }
      });
    },
    quitarItem(detalleSolicitudPagoId) {
      this.detallesSolicitudesPagosAgrupados = this.detallesSolicitudesPagosAgrupados.filter(
        (item) => item.detalleSolicitudPagoId !== detalleSolicitudPagoId,
      );
      this.item = null;
    },
  },
};
</script>

<style scoped>
::v-deep .v-select.v-text-field--outlined:not(.v-text-field--single-line).v-input--dense .v-select__selections {
  padding: 0px 0;
}

::v-deep .v-text-field .v-input__control .v-input__slot {
  min-height: auto !important;
  display: flex !important;
  align-items: center !important;
}

::v-deep .v-text-field--outlined.v-input--dense .v-label {
  top: 5px;
}

::v-deep .v-text-field .v-label {
  font-weight: 400;
}
</style>